"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOrderPipeLoyaltyToProxy = exports.mapOrderPipeLoyaltyToProxyItem = exports.getCheckoutPageFromCartType = exports.getPDP = exports.getIsAddressSet = exports.shouldHidePopover = exports.getBadgeAmount = exports.getRecoverableAmount = void 0;
const provider_1 = require("@cart/provider");
const constants_1 = require("./constants");
const getRecoverableAmount = (store) => {
    var _a;
    if (!((_a = store === null || store === void 0 ? void 0 : store.data) === null || _a === void 0 ? void 0 : _a.recoverable_items))
        return null;
    return store.data.recoverable_items.item_list.reduce((acc, cur) => acc + cur.quantity, 0);
};
exports.getRecoverableAmount = getRecoverableAmount;
const getBadgeAmount = (store) => {
    if (!(store === null || store === void 0 ? void 0 : store.data))
        return null;
    switch (store.status) {
        case provider_1.ResponseCode.EXPIRED:
            return (0, exports.getRecoverableAmount)(store);
        case provider_1.ResponseCode.SUCCESS:
        case provider_1.ResponseCode.CREATED:
        default:
            return store.data.total_units || store.data.unitCount;
    }
};
exports.getBadgeAmount = getBadgeAmount;
const shouldHidePopover = (store) => {
    var _a;
    const { data, status } = store;
    const proxyCart = data.cart_item_groups || data.recoverable_items || data.cart_loyalty_product;
    const orderPipe = !!((_a = data.deliveryGroups) === null || _a === void 0 ? void 0 : _a.length);
    return !data || (status !== provider_1.ResponseCode.EMPTY && !proxyCart && !orderPipe);
};
exports.shouldHidePopover = shouldHidePopover;
const getIsAddressSet = (cart) => {
    if (!cart || !cart.metadata || typeof cart.metadata.is_address_set === 'undefined')
        return true;
    return cart.metadata.is_address_set;
};
exports.getIsAddressSet = getIsAddressSet;
const getPDP = (item, locale, isLoyalty = false) => {
    if (isLoyalty)
        return;
    const { campaign_id: campaignId, product_family_id: familyId, product_family_id_string: familyIdString } = item;
    return `/gr/product/${campaignId}/${familyIdString || familyId}`;
};
exports.getPDP = getPDP;
const getCheckoutPageFromCartType = (cartType, isAddressSet) => {
    switch (cartType) {
        case provider_1.CartType.LEGACY:
        case provider_1.CartType.FLASH_SALES:
            return constants_1.OLD_CHECKOUT_PAGE;
        case provider_1.CartType.MARKETPLACE:
            return constants_1.OLD_BP_CHECKOUT_PAGE;
        case provider_1.CartType.NEW:
        default:
            return isAddressSet ? constants_1.CHECKOUT_PAGE : constants_1.NEW_ADDRESS_PAGE;
    }
};
exports.getCheckoutPageFromCartType = getCheckoutPageFromCartType;
const mapOrderPipeLoyaltyToProxyItem = (item) => {
    var _a, _b, _c;
    return ({
        item_id: 0,
        product_id: item.productId,
        product_family_id: parseInt((_a = item.productFamilyId) !== null && _a !== void 0 ? _a : '', 10),
        product_family_id_string: (_b = item.productFamilyId) !== null && _b !== void 0 ? _b : '',
        product_type: '',
        campaign_id: parseInt((_c = item.campaignId) !== null && _c !== void 0 ? _c : '', 10),
        campaign_code: item.campaignCode,
        campaign_name: item.campaignName,
        category_id: '',
        total_amount: item.totalAmount,
        total_MSRP: item.totalMsrp,
        total_savings: item.totalSavings,
        unit_amount: item.unitAmount,
        unit_amount_base: item.unitAmount,
        unit_MSRP: item.unitMsrp,
        unit_savings: item.unitSavings,
        retail_discount_percentage: undefined,
        quantity: item.quantity,
        quantity_increment: 1,
        image: item.image,
        size: item.size,
        item_name: item.productName,
        vat: -1,
    });
};
exports.mapOrderPipeLoyaltyToProxyItem = mapOrderPipeLoyaltyToProxyItem;
const mapOrderPipeLoyaltyToProxy = (item) => ({
    id: item.productId,
    name: item.productName,
    campaign_code: item.campaignCode,
    image: item.image,
    unit_amount: item.unitAmount,
    membership_lifespan: 0,
    membership_lifespan_unit: '',
});
exports.mapOrderPipeLoyaltyToProxy = mapOrderPipeLoyaltyToProxy;
